<template>
    <button @click.prevent="toggle" class="btn btn-gray p-2" :class="{ 'rounded-r-none': !approved}"><icon type="trash" class="block w-6 h-6" /></button>

    <modal v-model="show">
        <h1 class="heading-2">Delete Job Post</h1>

        <div>Are you sure you want to delete this job?</div>

        <form
            :action="url"
            @submit.prevent="deleteJob"
            method="post"
            class="space-y-4">
            <div>If so, type the words <span class="italic bg-gray-200 px-2 py-1 rounded-sm text-gray-800">Permanently Delete</span> into the field below.</div>
            <text-input
                label="Text"
                placeholder="Permanently Delete"
                v-model="form.text"
                :error="form.errors.text"
                help="This field case sensative. Make sure to capitalize the first letter of both words."
            />
        </form>

        <template #footer="{ close }">
            <div class="flex gap-4">
                <button @click.prevent="close" class="btn btn-gray flex-1">Cancel</button>
                <loading-button @click.prevent="deleteJob" :loading="form.processing" class="btn btn-green flex-1">Delete</loading-button>
            </div>
        </template>
    </modal>
</template>

<script setup>
import { ref } from 'vue'
import useForm from '@/functions/useForm';

const form = useForm({
    'text': ''
})

const props = defineProps({
    url: {
        type: String,
        default: true,
    },
    approved: {
        type: Boolean,
    }
})

const show = ref(false)

const toggle = () => show.value = !show.value
const deleteJob = () => form.delete(props.url)
</script>
